import { useEffect, useState } from "react";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { getChannelPermissions } from "@/api/guilds";

export const ChannelSendCheck = ({ guildId, channelId }) => {
  const [state, setState] = useState({ status: "idle" });

  useEffect(() => {
    if (!channelId) {
      setState({ status: "idle" });
      return;
    }
    let cancelled = false;
    setState({ status: "loading" });
    getChannelPermissions(guildId, channelId)
      .then((res) => !cancelled && setState({ status: "ok", perms: res.permissions }))
      .catch((e) => !cancelled && setState({ status: "error", message: e.message }));
    return () => {
      cancelled = true;
    };
  }, [guildId, channelId]);

  if (state.status === "idle") return null;
  if (state.status === "loading") {
    return (
      <p className="mt-2 flex items-center gap-2 text-xs text-paper-500" data-testid="channel-check-loading">
        <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden="true" />
        Checking channel permissions…
      </p>
    );
  }
  if (state.status === "error") {
    return (
      <p className="mt-2 flex items-center gap-2 text-xs text-paper-400" data-testid="channel-check-error">
        <XCircle className="h-3.5 w-3.5" aria-hidden="true" />
        {state.message}
      </p>
    );
  }
  const canSend = state.perms?.send_messages && state.perms?.embed_links;
  return (
    <p
      className={`mt-2 flex items-center gap-2 text-xs ${canSend ? "text-paper-200" : "text-paper-500"}`}
      data-testid={canSend ? "channel-check-ok" : "channel-check-blocked"}
    >
      {canSend ? <CheckCircle2 className="h-3.5 w-3.5" aria-hidden="true" /> : <XCircle className="h-3.5 w-3.5" aria-hidden="true" />}
      {canSend ? "Xevon can send embeds in this channel." : "Xevon cannot send embeds in this channel — pick another or fix its permissions."}
    </p>
  );
};
